import { RouteObject } from "react-router-dom";
import AdminLogin from "../modules/Admin/AdminAuth/AdminLogin";

const publicRoutes: RouteObject[] = [
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
];

export default publicRoutes;